const onClick = function onTabClick(ev) {
  const tab = ev.currentTarget;
  const tabpanel = ev.currentTarget.parentNode.querySelector('.js-tabpanel');
  const contentHeight = tabpanel.children[0].offsetHeight;
  const isOpen = tab.getAttribute('aria-expanded') === 'true';

  clearTimeout(tabpanel.timeoutEnd);
  clearTimeout(tabpanel.timeoutStart);
  tabpanel.setAttribute('style', `height: ${contentHeight}px`);

  if (isOpen) {
    tab.setAttribute('aria-expanded', 'false');
    tabpanel.setAttribute('aria-hidden', 'true');
    tabpanel.timeoutStart = setTimeout(() => {
      tabpanel.removeAttribute('style');
    }, 50);
    tab.focus({ preventScroll: true });
  } else {
    tab.setAttribute('aria-expanded', 'true');
    tabpanel.setAttribute('aria-hidden', 'false');
    tabpanel.timeoutEnd = setTimeout(() => {
      tabpanel.removeAttribute('style');
    }, 400);
    tabpanel.focus({ preventScroll: true });
  }
};

const init = function bindTabs() {
  [].forEach.call(
    document.querySelectorAll('.js-tab'),
    (el) => {
      el.removeEventListener('click', onClick);
      el.addEventListener('click', onClick);
    },
  );
};

const destroy = function destroyFaq() {
  [].forEach.call(
    document.querySelectorAll('.js-tab'),
    (el) => {
      el.removeEventListener('click', onClick);
    },
  );
};

export {
  destroy,
  init,
};
